export default __webpack_public_path__ + "static/media/necromancer.3fa53df5.png";